import { render, staticRenderFns } from "./NewStayForm.vue?vue&type=template&id=1b15d802"
import script from "./NewStayForm.vue?vue&type=script&lang=js"
export * from "./NewStayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports